module.exports = __webpack_public_path__ + "img/vip_sign_2.7e262a1f.png";